import { Component, OnInit } from '@angular/core';
import { VueSessionCookieService } from '@vue/vueframework';
import { makeHeader } from '../shared/connect.util';
import { TestCenterService } from '../shared/services/test-center.service';

@Component({
  selector: 'app-lite-shell',
  templateUrl: './lite-shell.component.html',
  styleUrls: [ './lite-shell.component.scss' ],
  standalone: false
})
export class LiteShellComponent implements OnInit {
  public siteHeaderDetail = '';
  
  public constructor(
    private vueSessionCookieService: VueSessionCookieService,
    private testCenterService: TestCenterService) {}
  
  public ngOnInit(): void {
    this.setHeader();
  }

  public setHeader(): void {
    const realm = JSON.parse(this.vueSessionCookieService.getAttribute('realmDetail', 'VUE'));
    const siteId = JSON.parse(this.vueSessionCookieService.getAttribute('siteID', 'VUE'));

    // If siteId is present, use that instead of realm to fetch new site header
    const selectedSiteId = siteId || realm.siteID;

    this.testCenterService.getTestCenterDetails(selectedSiteId).subscribe(
      (r) => {
        if (!r) {
          this.siteHeaderDetail = '';
          return;
        }
        const { name, id } = r[ 0 ];
        this.siteHeaderDetail = makeHeader(name, id);
      });
  }
}
